import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const useSelectDropdownStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {},
        header: {
            padding: '4px 0px 0px',

            [theme.breakpoints.up('md')]: {
                padding: '4px 16px 0px'
            }
        },
        headerItem: {
            paddingLeft: 0,
            paddingRight: 0
        },
        checkbox: {
            'padding': 0,
            'color': '#000000',

            '& .MuiSvgIcon-root': {
                fontSize: 18,
                fill: '#000000'
            }
        },
        search: {
            '&::after': {
                display: 'none'
            },
            '& .MuiInput-input': {
                paddingLeft: 6
            }
        },
        onlyDesktop: {
            [theme.breakpoints.down('sm')]: {
                display: 'none'
            }
        },
        footer: {
            'width': '100%',
            'padding': '12px 0px 4px',

            [theme.breakpoints.up('md')]: {
                padding: '12px 16px 4px'
            },

            '&, & *': {
                boxSizing: 'border-box'
            }
        }
    })
);
